import { render, staticRenderFns } from "./ZDMFailureReportAdmin.vue?vue&type=template&id=27a8577f&scoped=true&"
import script from "./ZDMFailureReportAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureReportAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8577f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
